var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1647_1560)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1647_1560",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1647_1560)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33325 3.29175C1.33325 2.94657 1.61752 2.66675 1.96817 2.66675H2.56805C3.99965 2.66675 5.25412 3.60993 5.6308 4.96951L8.60311 15.6977C8.86125 16.6294 8.66368 17.6289 8.07677 18.3991C7.12875 19.6435 8.02803 21.4167 9.58723 21.4167H27.365C27.7157 21.4167 27.9999 21.6966 27.9999 22.0417C27.9999 22.3869 27.7157 22.6667 27.365 22.6667H9.58723C6.96079 22.6667 5.49756 19.7011 7.06091 17.6491C7.41447 17.1851 7.53228 16.5834 7.37801 16.0266L4.4057 5.2984C4.17969 4.48267 3.42701 3.91675 2.56805 3.91675H1.96817C1.61752 3.91675 1.33325 3.63692 1.33325 3.29175ZM11.9999 28.0001C11.2635 28.0001 10.6666 27.4031 10.6666 26.6667C10.6666 25.9303 11.2635 25.3334 11.9999 25.3334C12.7363 25.3334 13.3333 25.9303 13.3333 26.6667C13.3333 27.4031 12.7363 28.0001 11.9999 28.0001ZM9.33325 26.6667C9.33325 25.1939 10.5272 24.0001 11.9999 24.0001C13.4727 24.0001 14.6666 25.1939 14.6666 26.6667C14.6666 28.1395 13.4727 29.3334 11.9999 29.3334C10.5272 29.3334 9.33325 28.1395 9.33325 26.6667ZM25.3333 28.0001C24.5969 28.0001 23.9999 27.4031 23.9999 26.6667C23.9999 25.9303 24.5969 25.3334 25.3333 25.3334C26.0697 25.3334 26.6666 25.9303 26.6666 26.6667C26.6666 27.4031 26.0697 28.0001 25.3333 28.0001ZM22.6666 26.6667C22.6666 25.1939 23.8605 24.0001 25.3333 24.0001C26.8061 24.0001 27.9999 25.1939 27.9999 26.6667C27.9999 28.1395 26.8061 29.3334 25.3333 29.3334C23.8605 29.3334 22.6666 28.1395 22.6666 26.6667ZM8.37428 6.00008H26.4259L24.2038 19.3334H11.7076L8.37428 6.00008ZM7.08074 6.32345C6.87037 5.48193 7.50685 4.66675 8.37428 4.66675H26.4259C27.2499 4.66675 27.8766 5.40657 27.7411 6.21928L25.519 19.5526C25.4118 20.1955 24.8555 20.6667 24.2038 20.6667H11.7076C11.0958 20.6667 10.5625 20.2503 10.4141 19.6567L7.08074 6.32345Z",
    fill: "#232528"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1647_1560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/icon-cart.b26cdfa0f5a7a92e533b55cffcb4b324.svg";
export { ForwardRef as ReactComponent };